import { VorgangProzessSchritt } from '@/features/schemaValidation/stepValidationSchemas';

export const VORGANG_PROZESS_SCHRITT_LABEL: Record<
  VorgangProzessSchritt,
  string
> = {
  [VorgangProzessSchritt.TRANSFORMATION]: 'Transformation',
  [VorgangProzessSchritt.FACHLICHE_VALIDIERUNG]: 'Fachliche Validierung',
  [VorgangProzessSchritt.WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER]:
    'Weiterleitung an Dokumentdienstleister',
  [VorgangProzessSchritt.ANTWORT_VON_DOKUMENTDIENSTLEISTER]:
    'Antwort von Dokumentdienstleister',
  [VorgangProzessSchritt.ARCHIVIERUNG]: 'Archivierung',
  [VorgangProzessSchritt.EMAIL_VERSAND]: 'E-Mail-Versand',
  [VorgangProzessSchritt.BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER]:
    'Bestätigung Verarbeitung beim Dokumentdienstleister',
  [VorgangProzessSchritt.WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS]:
    'Warte auf Reaktivierung des Dokumenttyps',
};
